import React from 'react'
import FixedLoader from 'app/views/components/FixedLoader'
import Icon from 'app/views/components/Icon'


class Loader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showResetButton: false,
    }
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        showResetButton: true,
      })
    }, 10000)
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  render() {
    return (
      <FixedLoader
        style={{
          display: 'flex',
          justiftContent: 'center',
          alignItems: 'center',
        }}
        text={this.state.showResetButton ? (
          <>
            <div className="uk-flex uk-flex-center  uk-flex-middle uk-text-center uk-width-large  uk-flex-column uk-margin-top">
              <p>The sandbox is taking longer than expected... </p>
              <button
                onClick={() => {
                  this.props.onResetSandbox()
                  this.setState({
                    showResetButton: false,
                  }, () => {
                    this.timeout = setTimeout(() => {
                      this.setState({
                        showResetButton: true,
                      })
                    }, 10000)
                  })
                }}
                className="uk-button uk-button-secondary uk-button-small"
                data-test-id="reset-sandbox-btn"
                style={{
                  textTransform: 'none',
                  fontSize: 13,
                  display: 'flex',
                  justiftContent: 'center',
                  alignItems: 'center',
                }}
                type="button"
              >
                <Icon className="uk-margin-small-right" name="restart" ratio={0.8} />
                <span>Reset Sandbox</span>
              </button>
            </div>
          </>
        ) : 'Loading Sandbox...'}
      />
    )
  }
}

export default Loader
